"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var useIntervalClick = function useIntervalClick(onLongClick) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var handle = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var clearHandle = function clearHandle() {
      return clearInterval(handle.current);
    };
    document.addEventListener('mouseup', clearHandle);
    return function () {
      document.removeEventListener('mouseup', clearHandle);
    };
  }, []);
  return {
    onMouseDown: function onMouseDown(e) {
      handle.current = window.setInterval(function () {
        return onLongClick(e);
      }, interval);
    },
    onClick: function onClick(e) {
      onLongClick(e);
    }
  };
};
var _default = exports["default"] = useIntervalClick;
//# sourceMappingURL=useIntervalClick.js.map